<div class="flex flex-col bg-surface-50 dark:bg-surface-950 h-full overflow-hidden">
    <div class="flex flex-col gap-3 p-3 flex-1 min-h-0 overflow-hidden">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-3 h-full">
            <!-- Knowledge Base Section -->
            <div class="lg:col-span-3 shadow rounded-base p-3 border flex flex-col gap-3 min-h-0">
                <div class="flex flex-col gap-2 h-full">
                    <div class="flex flex-wrap items-center justify-between">
                        <div class="text-surface-900 dark:text-surface-0 font-semibold text-lg">Knowledge base</div>
                        <app-button label="Create" variant="filled" severity="primary" icon="pi pi-plus"
                            (clicked)="handleKnowledgeBaseStoreAddDialogVisible(true)" class="text-sm" />
                    </div>

                    <div class="overflow-y-auto overflow-x-hidden min-h-0 max-h-[16vh] h-full lg:max-h-[calc(100vh-20vh)]"
                        infiniteScroll [infiniteScrollThrottle]="500" (scrolled)="onScroll()"
                        [infiniteScrollDistance]="1" [scrollWindow]="false">
                        @if(storeLoading && knowledgeBaseStore.length === 0){
                        @for (item of [0,1,2,3,4,5]; track $index) {
                        <div class="w-full h-16 sm:h-20 pt-2">
                            <p-skeleton width="100%" height="90%" />
                        </div>
                        }
                        }
                        @else{
                        @if(!knowledgeBaseStore || knowledgeBaseStore.length === 0) {
                        <p class="text-center h-full flex items-center justify-center text-sm text-gray-500">
                            No
                            knowledge
                            base store found</p>
                        }
                        @else {
                        @for (store of knowledgeBaseStore; track store._id) {
                        <div class="flex flex-row gap-2 border p-3 my-2 justify-between rounded-base items-center cursor-pointer"
                            (click)="selectStore(store)"
                            [ngClass]="{'active-key-point': selectedStore?._id === store._id}"
                            [pTooltip]="store.description">

                            <div class="flex flex-row gap-2 items-center flex-shrink-0">
                                <i [innerHTML]="SVGS.KNOWLEDGE_BASE_ICON | sanitizeHtml" alt="" class="w-6 h-6"></i>
                            </div>

                            <div class="flex flex-col justify-between gap-1 flex-1 min-w-0">
                                <div class="min-w-0">
                                    <div class="font-bold text-sm sm:text-base truncate">{{store.name || 'Loading...'}}
                                    </div>
                                </div>
                                <div class="flex flex-row w-full justify-between items-center">
                                    <div class="min-w-0 flex-1">
                                        <div class="text-xs sm:text-sm text-gray-600 truncate">{{store.description ||
                                            'Loading...'}}</div>
                                    </div>
                                </div>
                            </div>

                            <div (click)="handlePopoverOpen(ellipsisPopover); $event.stopPropagation()"
                                class="flex-shrink-0">
                                <app-popover #ellipsisPopover [width]="'auto'">
                                    <ng-template #trigger>
                                        <i [innerHTML]="SVGS.ELLIPSIS | sanitizeHtml" style="cursor: pointer;"></i>
                                    </ng-template>
                                    <ng-template #body>
                                        <div class="flex flex-col m-0">
                                            <div class="p-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2 rounded-base text-sm"
                                                (click)="selectStore(store); editKnowledgeBaseDetails(); ellipsisPopover.hide()">
                                                <span [innerHTML]="SVGS.PEN_EDIT | sanitizeHtml"></span>
                                                <span>Edit</span>
                                            </div>
                                            <div class="p-2 hover:bg-gray-100 text-danger cursor-pointer flex items-center gap-2 rounded-base text-sm"
                                                (click)="selectStore(store); openDeleteDialog(); ellipsisPopover.hide()">
                                                <span [innerHTML]="SVGS.RED_TRASH | sanitizeHtml"></span>
                                                <span>Delete</span>
                                            </div>
                                        </div>
                                    </ng-template>
                                </app-popover>
                            </div>
                        </div>
                        }
                        @if(loadingMore) {
                        @for (item of [1,2]; track $index) {
                        <div class="w-full h-16 sm:h-20 pt-2">
                            <p-skeleton width="100%" height="90%" />
                        </div>
                        }
                        }
                        }
                        }
                    </div>
                </div>
            </div>

            <!-- Knowledge Base Details Section -->
            <div class="lg:col-span-9 flex flex-col gap-3 min-h-0">
                <div class="flex flex-col h-full overflow-hidden">
                    @if(storeLoading){
                    <div class="flex flex-col gap-4 h-full">
                        @for (item of [0,1,2,3,4,5]; track $index) {
                        <div class="w-full h-16 sm:h-20">
                            <p-skeleton width="auto" height="100%" />
                        </div>
                        }
                    </div>
                    }
                    @else {
                    @if(!knowledgeBaseStore || knowledgeBaseStore.length === 0) {
                    <p class="text-center h-full flex items-center justify-center text-sm text-gray-500">No knowledge
                        base store found</p>
                    }
                    @else {
                    @if(selectedStore){
                    <div class="flex flex-col gap-3 h-full w-full overflow-hidden">
                        <div
                            class="flex flex-col sm:flex-row gap-2 justify-between items-start sm:items-center flex-shrink-0 mb-2">
                            <div class="flex flex-col gap-1 sm:gap-2 w-full sm:w-auto">
                                <div class="flex flex-row items-center gap-2">
                                    <span #editableContent scrollReset
                                        class="text-lg sm:text-xl md:text-2xl font-bold max-w-full whitespace-nowrap overflow-x-auto inline-block no-scrollbar"
                                        [class.editing]="isEditing" [attr.contenteditable]="isEditing"
                                        (keydown)="$event.key === 'Enter' ? blurSpan($event) : null"
                                        (blur)="updateStoreName($event)">
                                        {{selectedStore.name || 'Loading...'}}
                                        <span class=" font-semibold text-gray-500">({{selectedStore.files.length ||
                                            0}})</span>
                                    </span>
                                </div>
                            </div>
                            <div class="flex flex-row gap-2 items-center w-full sm:w-auto justify-end">
                                <app-button variant="outlined" severity="contrast"
                                    [icon]="(isEditing ? 'pi pi-times' : 'pi pi-pencil')" (clicked)="toggleEdit()"
                                    class="flex-1 sm:flex-none" />
                                <app-button variant="outlined" severity="danger" icon="pi pi-trash"
                                    (clicked)="showDeleteKnowledgeBaseStoreDialog = true" class="flex-1 sm:flex-none" />
                            </div>
                        </div>
                        <p-panel #detailPanel id="peopleTrackerPanel" [toggleable]="true"
                            class="border rounded-base w-full custom-panel-left-toggle"
                            [ngClass]="{'collapsed-panel': isDetailsCollapsed}" [collapsed]="true">
                            <ng-template pTemplate="header">
                                <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-3 w-full cursor-pointer"
                                    (click)="togglePeopleTrackerPanel($event)" step-id="project-dashboard-step1">
                                    <div class="flex items-center gap-2 min-w-0">
                                        <h2 class="text-base sm:text-lg font-bold truncate">Details</h2>
                                    </div>
                                </div>
                            </ng-template>

                            <div class="flex flex-col h-full">
                                <div class="flex-1">
                                    @if(storeLoading) {
                                    <div class="flex flex-col gap-4 p-3">
                                        @for(i of [1,2,3,4]; track i) {
                                        <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                                        }
                                    </div>
                                    }@else {
                                    <div class="flex flex-col gap-2">
                                        <div class="flex justify-between">
                                            <div class="flex items-center gap-4 w-[50%]">
                                                <div
                                                    class="flex items-center gap-2 min-w-[30%] text-gray-500 mb-1 sm:mb-0">
                                                    <i [innerHTML]="SVGS.NUMBER_OF_FILES | sanitizeHtml"
                                                        class="flex-shrink-0"></i>
                                                    <span class="font-medium truncate">Number of files</span>
                                                </div>

                                                <div class="text-sm font-semibold truncate">{{selectedStore.files.length
                                                    || 0}}</div>
                                            </div>
                                            <div class="flex items-center gap-4 w-[50%] border-l border-gray-200 pl-3">
                                                <div
                                                    class="flex items-center gap-2 min-w-[30%] text-gray-500 mb-1 sm:mb-0">
                                                    <i [innerHTML]="SVGS.DESCRIPTION | sanitizeHtml"
                                                        class="flex-shrink-0"></i>
                                                    <span class="font-medium truncate">Description</span>
                                                </div>

                                                <div class="text-sm font-semibold">{{selectedStore.description ||
                                                    'N/A'}}</div>
                                            </div>
                                        </div>
                                        <div class="border-t border-gray-200"></div>
                                        <div class="flex justify-between">
                                            <div class="flex items-center gap-4 w-[50%]">
                                                <div
                                                    class="flex items-center gap-2 min-w-[30%] text-gray-500 mb-1 sm:mb-0">
                                                    <i [innerHTML]="SVGS.DATE_CREATED | sanitizeHtml"
                                                        class="flex-shrink-0"></i>
                                                    <span class="font-medium truncate">Date created</span>
                                                </div>

                                                <div class="text-sm font-semibold truncate">{{selectedStore.createdAt |
                                                    date}}</div>
                                            </div>
                                            <div class="flex items-center gap-4 w-[50%] border-l border-gray-200 pl-3">
                                                <div
                                                    class="flex items-center gap-2 min-w-[30%] text-gray-500 mb-1 sm:mb-0">
                                                    <i [innerHTML]="SVGS.DATE_MODIFIED | sanitizeHtml"
                                                        class="flex-shrink-0"></i>
                                                    <span class="font-medium truncate">Date modified</span>
                                                </div>

                                                <div class="text-sm font-semibold">{{selectedStore.updatedAt | date}}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    }
                                </div>
                            </div>
                        </p-panel>

                        <div class="flex gap-2">
                            <app-button label="Add files" variant="filled" severity="primary" icon="pi pi-plus"
                                (clicked)="openAddFileInKnowledgeBase()" class="text-sm" />
                            <app-search-bar placeholder="Search" width="100%" (search)="searchFiles()"
                                [(ngModel)]="filesSearchValue" />
                        </div>

                        <div class="flex flex-col w-full flex-1 min-h-0 overflow-hidden">
                            <div class="flex flex-col h-full w-full overflow-hidden">
                                @if(selectedStore.files.length || selectedStore.status ===
                                KNOWLEDGE_BASE_STORE_STATUS.UPLOADING){
                                @if(selectedFiles.length) {
                                <div
                                    class="flex flex-col sm:flex-row gap-2 p-2 border rounded-base shadow-sm justify-between items-start sm:items-center flex-shrink-0 mb-2">
                                    <div class="flex flex-row flex-wrap items-center gap-2">
                                        <p class="text-xs sm:text-sm font-medium">
                                            {{ selectedFiles.length }} item{{ selectedFiles.length > 1 ? 's' : '' }}
                                            selected
                                        </p>
                                        <div class="hidden sm:block h-6 w-px bg-gray-300 mx-2"></div>

                                        <app-button label="Download" variant="outlined" icon="pi pi-download"
                                            (clicked)="downloadSelected()" class="text-sm" />
                                    </div>
                                    <div
                                        class="flex flex-row items-center gap-2 w-full sm:w-auto justify-end flex-wrap">
                                        <app-button
                                            [label]="selectedFiles.length > 1 ? 'Bulk delink from knowledge mapping' : 'Delink from knowledge mapping'"
                                            variant="outlined" severity="contrast" icon="pi pi-link"
                                            (clicked)="openDelinkPanel()" class="text-sm" />
                                        <app-button label="Delete" variant="outlined" severity="danger"
                                            icon="pi pi-trash" (clicked)="openDeleteDialogBox()" class="text-sm" />
                                    </div>
                                </div>

                                }
                                <div class="flex-1 min-h-0 overflow-hidden">
                                    <app-data-table [data]="filteredStoreFiles || []" [columns]="tableColumns"
                                        [dataKey]="'file._id'" [config]="tableConfig" [customTemplates]="templatesMap"
                                        (selectionChange)="onSelectionChange($event)" tableClass="text-sm">

                                        <!-- File Name Template -->
                                        <ng-template #fileNameTemplate let-data>
                                            <span class="truncate text-sm text-gray-600">{{data.file?.name}}</span>
                                        </ng-template>

                                        <!-- Added By Template -->
                                        <ng-template #addedByTemplate let-data>
                                            <div class="flex items-center gap-1">
                                                <app-user-name-display [user]="data.createdBy"
                                                    [variant]="'avatar-name'">
                                                </app-user-name-display>
                                            </div>
                                        </ng-template>

                                        <!-- Times Used Template -->
                                        <ng-template #timesUsedTemplate let-data>
                                            <span class="flex text-xs text-gray-600 justify-between items-center">
                                                {{data.numberOfTimesUsed ?? 0}}
                                            </span>
                                        </ng-template>

                                        <!-- Added On Template -->
                                        <ng-template #addedOnTemplate let-data>
                                            <span class="text-xs text-gray-600 inline-flex items-center gap-1">
                                                <i [innerHTML]="SVGS.CALENDER_DAYS | sanitizeHtml"
                                                    class="mb-0.5 w-4 h-4"></i>
                                                {{ data.file?.createdAt | date: 'd MMM yyyy' }}
                                            </span>
                                        </ng-template>

                                        <!-- Actions Template -->
                                        <ng-template #actionsTemplate let-data>
                                            <div class="flex items-center justify-center"
                                                (click)="$event.stopPropagation()">
                                                <app-popover #menu width="12rem">
                                                    <ng-template #trigger>
                                                        <i class="pi pi-ellipsis-v cursor-pointer icon-sm"></i>
                                                    </ng-template>
                                                    <ng-template #body>
                                                        <div class="flex flex-col text-sm">
                                                            <div (click)="openDocumentPreview(data.file); menu.hide()"
                                                                class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                                                                <i class="pi pi-eye text-sm"></i>
                                                                <span>View</span>
                                                            </div>
                                                            <div (click)="openDelinkPanel($event, data.file._id, selectedStore); menu.hide()"
                                                                class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                                                                <i class="pi pi-link text-sm"></i>
                                                                <span>Delink</span>
                                                            </div>
                                                            <div (click)="openDeleteDialogBox($event, data.file._id, selectedStore._id); menu.hide()"
                                                                class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors text-danger">
                                                                <i class="pi pi-trash text-sm"></i>
                                                                <span>Delete</span>
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                </app-popover>
                                            </div>
                                        </ng-template>
                                    </app-data-table>
                                </div>
                                }
                                @else {
                                <p class="text-center text-sm text-gray-500 p-4">No files attached</p>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    }
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<app-dialog [(visible)]="knowledgeBaseStoreAddDialogVisible" title="Create Knowledge Base Store"
    (closed)="handleKnowledgeBaseStoreAddDialogVisible(false)" class="max-w-[600px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-2 p-4">
            <form [formGroup]="knowledgeBaseStoreForm">
                <div class="flex flex-col align-items-center gap-1 mb-3">
                    <label for="name" class="w-full text-sm sm:text-base">
                        Name<span class="text-danger">*</span>
                    </label>
                    <input name="name" formControlName="name" placeholder="Enter Knowledge Base Store Name"
                        class="w-full border outline-none rounded-base input p-2 text-sm sm:text-base"
                        autocomplete="off" required />
                    <div *ngIf="knowledgeBaseStoreFormControls['name'].invalid && (knowledgeBaseStoreFormControls['name'].dirty)"
                        class="text-danger text-xs w-full">
                        {{"Name is required." | titlecase}}
                    </div>
                </div>
                <div class="flex flex-col align-items-center gap-1 mb-3">
                    <label for="description" class="w-full text-sm sm:text-base">
                        Description<span class="text-danger">*</span>
                    </label>
                    <textarea id="description" name="description" formControlName="description"
                        class="w-full border outline-none rounded-base input p-2 text-sm sm:text-base"
                        placeholder="Enter Knowledge Base Store Description" autocomplete="off" required
                        rows="4"></textarea>
                    <div *ngIf="knowledgeBaseStoreFormControls['description'].invalid && (knowledgeBaseStoreFormControls['description'].dirty)"
                        class="text-danger text-xs w-full">
                        {{"Description is required." | titlecase}}
                    </div>
                </div>
                <div class="flex flex-col align-items-center gap-1 mb-3">
                    <label for="files" class="w-full mb-2 text-sm sm:text-base">
                        Select files to upload<span class="text-danger">*</span>
                    </label>
                    <div class="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                        <app-button label="Link existing files" variant="outlined" icon="pi pi-file-import"
                            (clicked)="openLinkFilesDialog()" class="w-full sm:w-auto text-sm" />
                        <app-button label="Upload new files" variant="outlined" icon="pi pi-cloud-upload"
                            (clicked)="showUploadDrop = true" [ngClass]="{'active': showUploadDrop}"
                            class="w-full sm:w-auto text-sm" />
                    </div>
                    <div class="w-full mt-4" *ngIf="showUploadDrop">
                        <app-file-drop (uploadData)="onFileUploaded($event)" (removeFile)="onFileRemove($event)"
                            [fileTypes]="allowedFileTypes" [maxFileSize]="50 * 1000 * 1000" [multiple]="true"
                            [existingFiles]="files"></app-file-drop>
                        @if(uploadingFiles) {
                        <div class="mt-2 flex flex-col gap-1">
                            <p class="text-xs text-gray-600">Uploading {{ uploadedCount }} of {{ uploadTotal }} file{{
                                uploadTotal > 1 ? 's' : '' }}...</p>
                            <p-progressBar [value]="uploadTotal ? (uploadedCount / uploadTotal) * 100 : 0"
                                [showValue]="false" color="#FF6A2A" [style]="{'height': '6px'}" />
                        </div>
                        }
                    </div>
                </div>
            </form>
            @if(selectedFilesForLinking.length > 0){
            <div class="flex flex-col gap-2 p-2">
                <p class="text-sm font-medium text-gray-700 mb-2">Files selected for linking</p>
                <div class="flex flex-wrap gap-2">
                    <div *ngFor="let file of selectedFilesForLinking" class="flex items-center gap-2 bg-white border border-gray-200 shadow-sm rounded-base p-2
                             w-full" [ngClass]="{
                        'sm:w-full': selectedFilesForLinking.length === 1,
                        'sm:w-[calc(50%-0.5rem)] md:w-[calc(33.33%-0.5rem)]': selectedFilesForLinking.length > 1}">
                        <div class="w-7 h-7 flex items-center justify-center flex-shrink-0">
                            @if(file.mimeType == 'pdf'){
                            <i [innerHTML]="SVGS.PDF | sanitizeHtml"></i>
                            } @else if(file.mimeType == 'docx'){
                            <i [innerHTML]="SVGS.DOCX | sanitizeHtml"></i>
                            } @else {
                            <i class="pi pi-file text-gray-400 text-lg"></i>
                            }
                        </div>
                        <div class="flex-1 overflow-hidden">
                            <span class="text-sm font-medium text-gray-800 truncate block">{{ file.name }}</span>
                        </div>
                        <app-button variant="outlined" severity="danger" icon="pi pi-times"
                            (clicked)="removeSelectedFile(file)" />
                    </div>
                </div>
            </div>
            }
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="handleKnowledgeBaseStoreAddDialogVisible(false)" class="w-full sm:w-auto" />
            <app-button variant="filled" severity="primary" label="Create" icon="pi pi-plus"
                (clicked)="createKnowledgeBaseStore()" [enableThrottle]="true" [loading]="submitting"
                [disabled]="submitting || knowledgeBaseStoreFormControls['name'].invalid || knowledgeBaseStoreFormControls['description'].invalid || (!selectedFilesForLinking.length && !files.length)"
                class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showDeLinkPanel" (closed)="showDeLinkPanel = false" class="max-w-[500px]"
    [fullscreenOnMobile]="true">
    <ng-template #headerTemplate>
        <span class="flex items-center gap-2 text-base sm:text-lg">
            <i [innerHTML]="SVGS.DELINK | sanitizeHtml"></i>
            @if(deLinkItemId){
            <span class="font-bold">Delink the document?</span>
            } @else {
            <span class="font-bold">Delink the files or documents?</span>
            }
        </span>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="p-4">
            @if(deLinkItemId){
            <p class="text-sm sm:text-base">This file will be removed from the current knowledge base, but won't be
                deleted from the files.</p>
            } @else {
            <p class="text-sm sm:text-base">Are you sure you want to delink these {{selectedFiles.length}} files from
                the current knowledge mapping?</p>
            }
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        @if(deLinkItemId && deLinkItemStoreId){
        <div class="flex flex-col sm:flex-row gap-2 justify-end">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="showDeLinkPanel = false" class="w-full sm:w-auto" />
            <app-button variant="outlined" label="Delink" severity="danger" icon="pi pi-link"
                (clicked)="deLinkFile([deLinkItemId], deLinkItemStoreId)" class="w-full sm:w-auto" />
        </div>
        } @else if(selectedFiles.length > 0){
        <div class="flex flex-col sm:flex-row gap-2 justify-end">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="showDeLinkPanel = false" class="w-full sm:w-auto" />
            <app-button variant="outlined" severity="danger" label="Delink" icon="pi pi-link"
                (clicked)="deLinkFile(selectedFiles, selectedStore)" class="w-full sm:w-auto" />
        </div>
        }
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="openEditKnowledgeBasePanel" title="Rename Knowledge Base"
    (closed)="openEditKnowledgeBasePanel = false" class="max-w-[500px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col gap-3 p-4">
            <div>
                <h1 class="mb-2 text-gray-500 font-semibold text-sm sm:text-base">Name</h1>
                <input type="text" [(ngModel)]="editedStore.name"
                    class="w-full px-3 py-2 sm:py-3 border border-gray-300 rounded-base text-sm outline-none focus:border-orange-500" />
            </div>
            <div>
                <h1 class="mb-2 text-gray-500 font-semibold text-sm sm:text-base">Knowledge Base Description</h1>
                <textarea pInputTextarea [(ngModel)]="editedStore.description"
                    class="w-full px-3 py-2 sm:py-3 border border-gray-300 rounded-base text-sm outline-none placeholder:text-black focus:border-orange-500"
                    rows="4"></textarea>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="openEditKnowledgeBasePanel = false" class="w-full sm:w-auto" />
            <app-button variant="filled" label="Save Changes" icon="pi pi-save" severity="primary"
                (clicked)="renameKnowledgeBase()" class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

@if(showDeleteDialogBox) {
<app-delete-confirmation [(visible)]="showDeleteDialogBox" width="30vw" [style]="{'max-width': '600px'}"
    confirmButtonText="Yes, Delete"
    (onConfirm)="deleteFileId ? deleteFiles(deleteFileId, selectedKnowledgeBase) : deleteFiles()" [closable]="false">
    <ng-template #headerTemplate>
        <span class="flex justify-start items-start min-w-0 gap-3">
            <div class="flex justify-center items-center w-7 h-7 mt-1 flex-shrink-0">
                <i [innerHTML]="SVGS.RED_TRASH | sanitizeHtml" style="cursor: pointer;"></i>
            </div>
            <ng-container *ngIf="deleteFileId; else deleteMultiple">
                <div class="flex flex-col gap-1">
                    <span class="font-bold">Delete the file?</span>
                    <span class="text-sm text-gray-500">This file will be permanently deleted from the {{scope ===
                        KNOWLEDGE_SCOPE.PROJECT ? 'project' : 'workspace'}}
                        knowledge.</span>
                </div>
            </ng-container>
            <ng-template #deleteMultiple>
                <span class="font-bold">Delete {{selectedFiles.length}} files?</span>
            </ng-template>
        </span>
    </ng-template>
    <ng-template #bodyTemplate>
        <ng-container *ngIf="deleteFileId; else deleteMultipleFiles">
            <p class="text-sm text-gray-700">
                This file will be permanently deleted from the files. If you only want to remove it from this knowledge
                base,
                please click on 'Delink' instead. Do you want to proceed with deleting this file?
            </p>
        </ng-container>
        <ng-template #deleteMultipleFiles>
            <p class="text-sm text-gray-700">
                Selected files will be permanently deleted from the files. If you only want to remove it from this
                knowledge
                base, please click on 'Delink' instead.
            </p>
        </ng-template>
    </ng-template>
</app-delete-confirmation>
}


<app-dialog [(visible)]="openAddFileToKnowledgeBase" title="Add Files" (closed)="openAddFileToKnowledgeBase = false"
    class="max-w-[600px]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <section class="flex flex-col sm:flex-row gap-3 sm:gap-4 p-4">
            <p-card
                class="border border-gray-200 text-center shadow-sm hover:shadow-md transition-shadow !flex flex-1 flex-col items-center justify-center p-4 cursor-pointer min-h-[120px]"
                (click)="openLinkExistingFiles()">
                <div class="flex items-center justify-center gap-2">
                    <i [innerHTML]="SVGS.LINK_EXISTING_FILES | sanitizeHtml"></i>
                    <span class="text-sm sm:text-base">Link Existing Files</span>
                </div>
            </p-card>
            <p-card
                class="border border-gray-200 text-center shadow-sm hover:shadow-md transition-shadow !flex flex-1 flex-col items-center justify-center p-4 cursor-pointer"
                (click)="uploadFile()">
                <div class="flex items-center justify-center gap-2">
                    <i [innerHTML]="SVGS.UPLOAD_NEW_FILE | sanitizeHtml"></i>
                    <span class="text-sm sm:text-base">Upload New Files</span>
                </div>
            </p-card>
        </section>
    </ng-template>
</app-dialog>
<app-dialog [(visible)]="openLinkExistingFilePanel" [title]="selectedStore?.name ?? ''"
    (closed)="closeLinkExistingFilePanel()" class="max-w-[800px] h-[85vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="flex flex-col h-full p-4">
            <h2 class="font-semibold text-sm sm:text-base mb-2">Link Files from Repository</h2>
            <div class="my-2 flex items-center gap-2 w-full">
                <app-search-bar placeholder="Search" [(ngModel)]="linkingSearchValue" (searchChange)="onLinkingSearch()"
                    width="100%"></app-search-bar>
            </div>
            <div class="flex-1 overflow-hidden">
                @if(filteredFilesForLinking.length > 0) {
                <div class="h-full overflow-y-auto">
                    <div class="flex items-center gap-3 p-3 border-b border-gray-200 sticky top-0 bg-white z-10">
                        <app-checkbox
                            [value]="selectedFilesForLinking.length === filteredFilesForLinking.length && filteredFilesForLinking.length > 0"
                            (onChange)="toggleSelectAll($event)" [config]="{ binary: true, label: 'Select All' }" />
                        @if(selectedFilesForLinking.length > 0) {
                        <span class="text-xs text-gray-500">({{ selectedFilesForLinking.length }} selected)</span>
                        }
                    </div>
                    <div class="divide-y divide-gray-100">
                        @for(file of filteredFilesForLinking; track file._id) {
                        <div class="flex items-center gap-3 p-3 hover:bg-gray-50 transition-colors"
                            [class.bg-orange-50]="checkIfFileIsLinked(file)">
                            <app-checkbox [value]="checkIfFileIsLinked(file)"
                                (onChange)="toggleFileSelection(file, $event)" [config]="{ binary: true }" />
                            <div class="flex-1 min-w-0">
                                <div class="flex items-center gap-2">
                                    <div class="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                                        @if(file.mimeType === "pdf") {
                                        <i [innerHTML]="SVGS.PDF | sanitizeHtml" class="text-danger"></i>
                                        } @else if(file.mimeType === "docx") {
                                        <i [innerHTML]="SVGS.DOCX | sanitizeHtml" class="text-blue-500"></i>
                                        } @else {
                                        <i class="pi pi-file text-gray-500"></i>
                                        }
                                    </div>
                                    <div class="flex-1 min-w-0">
                                        <div class="flex items-center justify-between">
                                            <div class="flex-1 min-w-0">
                                                <p class="text-sm font-medium text-gray-900 truncate">{{ file.name }}
                                                </p>
                                                <p class="text-xs text-gray-500">{{ file.mimeType }} • Added by
                                                    <app-user-name-display
                                                        [user]="file.createdBy"></app-user-name-display>
                                                </p>
                                            </div>
                                            <div class="flex flex-wrap gap-1 ml-4">
                                                @if(getKnowledgeBasesForFile(file).length > 0) {
                                                @for(kb of getKnowledgeBasesForFile(file).slice(0, 2); track kb._id) {
                                                <span
                                                    class="inline-block bg-slate-100 border border-gray-200 text-black text-xs px-2 py-1 rounded-full font-medium">
                                                    {{ kb.name }}
                                                </span>
                                                }
                                                @if(getKnowledgeBasesForFile(file).length > 2) {
                                                <span
                                                    class="inline-block bg-slate-100 border border-gray-200 text-black text-xs px-2 py-1 rounded-full font-medium">
                                                    +{{ getKnowledgeBasesForFile(file).length - 2 }}
                                                </span>
                                                }
                                                } @else {
                                                <span class="text-xs text-gray-400">No KB linked</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                } @else {
                <div class="flex justify-center items-center h-64">
                    @if(filesForLinkingLoading) {
                    <div class="text-center">
                        <i class="pi pi-spinner pi-spin text-2xl text-arena-orange"></i>
                        <p class="mt-2 text-gray-500">Loading files...</p>
                    </div>
                    } @else if(linkingSearchValue.trim()) {
                    <div class="text-center text-gray-500">
                        <i class="pi pi-search text-3xl mb-2"></i>
                        <p class="text-lg">No files found matching "{{ linkingSearchValue }}"</p>
                        <p class="text-sm">Try adjusting your search terms</p>
                    </div>
                    } @else {
                    <div class="text-center text-gray-500">
                        <i class="pi pi-file text-3xl mb-2"></i>
                        <p class="text-lg">No files available</p>
                        <p class="text-sm">Upload files to the repository first</p>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex flex-col sm:flex-row justify-end gap-2">
            <app-button variant="outlined" label="Cancel" severity="contrast" icon="pi pi-times"
                (clicked)="closeLinkExistingFilePanel()" class="w-full sm:w-auto" />
            <app-button variant="filled" label="Link Selected" icon="pi pi-link" severity="primary"
                (clicked)="linkSelectedFilesToStore()" [disabled]="selectedFilesForLinking.length === 0"
                class="w-full sm:w-auto" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [(visible)]="showDocumentPreview" [title]="selectedFile?.name ?? ''" (closed)="closeDocumentPreview()"
    class="max-w-4xl h-[90vh]" [fullscreenOnMobile]="true">
    <ng-template #bodyTemplate>
        <div class="h-full w-full">
            @if(selectedDocumentFile && selectedDocumentId) {
            <app-document-preview [documentId]="selectedDocumentId" [file]="selectedDocumentFile">
            </app-document-preview>
            }
        </div>
    </ng-template>
</app-dialog>

@if(showDeleteKnowledgeBaseStoreDialog){
<app-delete-confirmation [(visible)]="showDeleteKnowledgeBaseStoreDialog" width="90vw" [style]="{'max-width': '600px'}"
    bodyText="This knowledge base will be permanently deleted and cannot be recovered. However, the files will not be deleted and can still be found under the Files section."
    confirmButtonText="Yes, Delete" (onConfirm)="deleteStore(selectedStore?._id ?? '')">
    <ng-template #headerTemplate>
        <div class="flex gap-2 items-center w-full">
            <i [innerHTML]="SVGS.RED_TRASH | sanitizeHtml" class="text-danger flex-shrink-0"></i>
            <div class="text-sm sm:text-base font-bold truncate">Delete '{{selectedStore?.name}}' ?</div>
        </div>
    </ng-template>
</app-delete-confirmation>
}
